import { Link, ListItemButtonProps, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import * as S from './Sidebar.styles';
import { NavListProps } from '@organisms/Sidebar/Sidebar.types';
import { ReactComponent as DownBtn } from '@assets/icons/ic-eva_arrow-ios-downward-fill.svg';
import { ReactComponent as ForwardBtn } from '@assets/icons/ic-eva_arrow-ios-forward-fill.svg';
import { forwardRef } from 'react';
import { PATHS } from '@routes/paths';
import { useTranslation } from 'react-i18next';

interface ISideItemProps extends ListItemButtonProps {
  data: NavListProps;
  depth: number;
  active: boolean;
  open: boolean;
  isMini: boolean;
}

const SideItem = forwardRef<HTMLDivElement, ISideItemProps>(
  ({ data, depth, active, open, isMini, ...other }, ref) => {
    const { title, icon, children, path } = data;
    const subItem = depth !== 1;

    const { t } = useTranslation();

    const convertPath = (path: string) => {
      const indexPath = [PATHS.badge.index];
      if (indexPath.includes(path)) {
        const pathRoot = path.split('/')[1];
        return `/${pathRoot}/list`;
      }

      return path;
    };

    const renderContent = (
      <>
        <S.StyledItem
          active={active}
          depth={depth}
          isMini={isMini}
          ref={ref}
          {...other}
        >
          {icon && <S.StyledIcon isMini={isMini}>{icon}</S.StyledIcon>}
          {subItem && !isMini && (
            <S.StyledIcon isMini={isMini}>
              <S.StyledDotIcon active={active && subItem} />
            </S.StyledIcon>
          )}
          <S.StyledListItemText
            primary={t(title)}
            isMini={isMini}
            active={active}
            primaryTypographyProps={{
              noWrap: true,
              component: 'span',
            }}
          />

          {children && !isMini && <>{open ? <DownBtn /> : <ForwardBtn />}</>}
          {children && isMini && (
            <Stack
              sx={{
                position: 'absolute',
                top: 11,
                right: 0,
                zIndex: 1000,
              }}
            >
              <ForwardBtn sx={{ margin: '0px' }} />
            </Stack>
          )}
        </S.StyledItem>
      </>
    );

    const renderItem = () => {
      if (children && !isMini) {
        return renderContent;
      }

      return (
        <Link component={RouterLink} to={convertPath(path)} underline="none">
          {renderContent}
        </Link>
      );
    };

    return <>{renderItem()}</>;
  },
);

SideItem.displayName = 'SideItem';

export default SideItem;
